import { template } from "lodash";
import { CustomerTemplate, FieldError, FieldInfo, SignatureInfo } from "../../src/types";
import { christmasTemplateData } from "./templates/christmasTemplateData";
import { birthdayTemplateData } from "./templates/birthdayTemplateData";
import { easterTemplateData } from "./templates/easterTemplateData";
import { griefTemplateData } from "./templates/griefTemplateData";
import { invitationTemplateData } from "./templates/invitationTemplateData";
import { marriageTemplateData } from "./templates/marriageTemplateData";


export const templates: CustomerTemplate[] = [
    
        christmasTemplateData,
        birthdayTemplateData,
        easterTemplateData,
        marriageTemplateData,
        griefTemplateData,
        invitationTemplateData,
]